// components/Donation/DonationFormModal.jsx
import { Box, Typography, Modal, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DonationForm from "./DonationForm";

const DonationFormModal = ({ open, onClose, editData, onSubmit, formRef }) => {
  return (
    <Modal open={open} onClose={onClose}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Box sx={{ width: "100%", maxWidth: 900, background: "white", borderRadius: 2 }}>
        
        <div style={{
          background: "#1976D2", color: "white", padding: "16px",
          display: "flex", justifyContent: "space-between"
        }}>
          <Typography variant="h5">Donation Details</Typography>
          <IconButton onClick={onClose}><CloseIcon sx={{ color: "white" }} /></IconButton>
        </div>

        <div style={{ padding: "16px" }}>
          <DonationForm 
            initialData={editData}
            onSave={onSubmit}
            ref={formRef}
          />
        </div>

        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Button variant="contained" onClick={() => formRef.current.submitForm()}>
            {editData?.transactionId ? "Update Donation" : "Add Donation"}
          </Button>

          <Button variant="contained" color="error" sx={{ ml: 1 }} onClick={onClose}>
            Close
          </Button>
        </Box>

      </Box>
    </Modal>
  );
};

export default DonationFormModal;
